// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"9b96665831e43c66","888":"d367e10dd2aadb3c"}[chunkId] + ".css";
};